import { test } from 'ramda';

import { APPLICATION_PATHS } from '@framework/constants/enums';
import getCanAccessBasedOnRoomPermissions from '@framework/guards/modules/common/activeRoomPermissionsGuard';
import {
    meetingsGuard,
    meetingsPermissionsGuard
} from '@framework/guards/modules/editor/meetingsGuard';
import {
    membersGuard,
    membersPermissionsGuard
} from '@framework/guards/modules/editor/membersGuard';
import { type RouteHandler } from '@framework/guards/type';

export const commonEditorGuard: RouteHandler<[], boolean> = {
    test: test(
        new RegExp(
            `/${APPLICATION_PATHS.ADMINISTRATOR}/${APPLICATION_PATHS.ROOMS}/([^/]+)/([^/]+)/`
        )
    ),
    handler: async (_ctx, contextMethods) => {
        const { call } = contextMethods;

        const canAccess = await call(getCanAccessBasedOnRoomPermissions, meetingsPermissionsGuard);
        return canAccess;
    }
};

export const editorPermissionsGuards = [...meetingsPermissionsGuard, ...membersPermissionsGuard];
export const editorGuards = [meetingsGuard, membersGuard, commonEditorGuard];
